/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} App_Slider_Reading_ViewInputs */

const en_app_slider_reading_view = /** @type {(inputs: App_Slider_Reading_ViewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reading View.`)
};

const es_app_slider_reading_view = /** @type {(inputs: App_Slider_Reading_ViewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vista de lectura.`)
};

/**
* | output |
* | --- |
* | "Reading View." |
*
* @param {App_Slider_Reading_ViewInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const app_slider_reading_view = /** @type {((inputs?: App_Slider_Reading_ViewInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<App_Slider_Reading_ViewInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_app_slider_reading_view(inputs)
	return en_app_slider_reading_view(inputs)
});